import React from 'react';

const StraiCoinIcon = ({ className = '', ...props }) => (
  <svg
    viewBox="0 0 27 27"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g transform="translate(2, 2) scale(0.85)">
      <path
        className="fill-current"
        d="M20.1,9.79h-3.63l2.18-4.27h-5.81l-5.81,11.39h4.36v5.7l8.71-12.81Z"
        transform="translate(-0.5, 0)"
      />
      <circle
        className="stroke-current"
        cx="13.5"
        cy="13.5"
        r="12.5"
        fill="none"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  </svg>
);

export default StraiCoinIcon;
